import { useTranslation } from 'react-i18next';

import type { Invoice } from '~/api/invoices/types';

import { useUser } from '~/api/user';
import { BrandDot, Icon, Tooltip } from '~/components';
import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleCellStyle, titleStyle, titleWrapperStyle } from './invoiceCell.css';

type Props = {
  invoice: Invoice;
};

export const InvoiceTitleCell = ({ invoice }: Props) => {
  const { t } = useTranslation(['common', 'invoices']);
  const { data: user } = useUser();

  const title = invoice.title || invoice.description;
  const brand = user.brands.find(({ id }) => id === invoice.brandId);

  return (
    <div className={titleCellStyle}>
      <div className={clsx(desktopTruncateStyle, titleWrapperStyle)}>
        <div className={clsx(titleStyle, desktopTruncateStyle)}>
          {brand && brand.color && <BrandDot color={brand.color} small />}

          <span className={desktopTruncateStyle}>{title || t('common:draft.defaultTitle')}</span>
        </div>

        {invoice.status !== 'Draft' && (
          <div className={desktopTruncateStyle}>
            <span>{invoice.fcEntryNumber}</span>
          </div>
        )}
      </div>

      {invoice.invoiceTemplateId !== null && (
        <Tooltip content={t('invoices:overview.createdFromTemplateTooltip')}>
          <Icon name="Sync" />
        </Tooltip>
      )}
    </div>
  );
};
